import { Pipe, PipeTransform } from '@angular/core';

import { Shipment } from '../../../pages/overview/models/shipment';

@Pipe({
  name: 'carrierInParenthesis',
  standalone: true
})
export class CarrierInParenthesisPipe implements PipeTransform {
  transform(shipment: Shipment): string {
    const isAirTransport = shipment.transportMode === 'Air';
    const text = isAirTransport ? shipment.routing.carrier : shipment.routing.carrierName;
    const text2 = isAirTransport ? shipment.routing.carrierName : shipment.routing.carrier;

    return text && text2 ? `${text} (${text2})` : text || text2 || '';
  }
}
